export * from "./patient.actions";
export * from "./test-order.actions";
export * from "./patient-search.actions";
export * from "./test-order-search.actions";
export * from "./phlebotomist-search.actions";
export * from "./office-staff-search.actions";
export * from "./office-staff.actions";
export * from "./test-order";
export * from "./location.actions";
export * from "./patient-reg.action";
export * from "./patient-test-results.actions";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/index.ts